import React, { createContext, Suspense, useContext, useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ThemeSwitcherProvider } from 'react-css-theme-switcher';
import store from './store';
import history from './history';
import Layouts from './layouts';
import { APP_NAME, THEME_CONFIG } from './configs/AppConfig';
import ErrorBoundary from 'error-boundary/ErrorBoundary';
import { AUTH_DEVICE_TOKEN } from 'constants/AuthConstant';
import { BellOutlined } from "@ant-design/icons";
import { notification } from 'antd';
import { getMessaging, onMessage } from "firebase/messaging";
import { tokenGenerator } from 'store/slices/authSlice';
import dayjs from 'dayjs';
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import ScrollToTop from 'components/ScrollToTop/ScrollToTop';

dayjs.extend(weekday);
dayjs.extend(localeData);

document.title = APP_NAME;

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`
};

const environment = process.env.NODE_ENV;

// if (environment !== 'production') {
// 	mockServer({ environment })
// }

export const AuthContext = createContext();

function App() {

  const [currentToken, setCurrentToken] = useState()

  //remove console from production
  if (process.env.NODE_ENV === "production") {
    console.log = () => { };
    console.warn = () => { };
    //console.error = () => {};
  }

  const generateToken = async () => {
    const permission = await Notification.requestPermission();
    console.log('notification permission', permission)

    // if (permission !== "granted") {
    //   throw new Error("Notification permission not granted.");

    // }

    const currentToken = await tokenGenerator();
    setTimeout(() => {
      localStorage.setItem(AUTH_DEVICE_TOKEN, currentToken)
    }, 1000)
    console.log('token before', currentToken)
    if (currentToken) {
      setCurrentToken(currentToken)
    }
    if (currentToken || currentToken == null) {

      console.log('token genrated in app', currentToken)
    }
  }

  console.log('current token rrr', currentToken)

  useEffect(() => {
    generateToken();
  }, [window.location])

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/firebase-messaging-sw.js')
        .then((registration) => {
          const messaging = getMessaging();
          // Normally, you would now listen for notifications like this:
          onMessage(messaging, (payload) => {
            console.log("Message received. ", payload);
            notification.open({
              message: payload.notification.title,
              description:
                payload.notification.body,
              icon: <BellOutlined style={{ color: "#108ee9" }} />, // Custom icon
            });
          });

          console.log("Service Worker registered successfully");
        })
        .catch((error) => {
          console.error("Service Worker registration failed:", error);
        });
    }
  }, []);


  // Register the service worker


  const messaging = getMessaging();

  useEffect(() => {
    // Listen for messages when the app is in the foreground
    onMessage(messaging, (payload) => {
      console.log("Message received. ", payload);
      notification.open({
        message: payload.notification.title,
        description:
          payload.notification.body,
        icon: <BellOutlined style={{ color: "#108ee9" }} />, // Custom icon
      });
    });
  }, []);

  onMessage(messaging, (payload) => {
    console.log("Message received. ", payload);
    notification.open({
      message: payload.notification.title,
      description:
        payload.notification.body,
      icon: <BellOutlined style={{ color: "#108ee9" }} />, // Custom icon
    });
  });

  const [loginData, setLoginData] = useState({
    token: null,
    roles: {},
    username: null,
    id: null,
    type: null,
  });

  const handleLogin = (data) => {
    setLoginData(data);
  };

  const handleLogout = () => {
    setLoginData({
      token: null,
      roles: {},
      username: null,
      id: null,
      type: null,
    });
  };

  return (
    <ErrorBoundary>
      <div className='App'>
        <AuthContext.Provider value={{ loginData, handleLogin, handleLogout }}>
          <Provider store={store}>
            <BrowserRouter history={history}>
              <ThemeSwitcherProvider
                themeMap={themes}
                defaultTheme={THEME_CONFIG.currentTheme}
                insertionPoint='styles-insertion-point'
              >
                <ScrollToTop />
                <Layouts />
              </ThemeSwitcherProvider>
            </BrowserRouter>
          </Provider>
        </AuthContext.Provider>
      </div>
    </ErrorBoundary>
  );
}

export default App;

